// extracted by mini-css-extract-plugin
export default {"keyMomentInformation":"jlQ7aFkwSBdUehcqnOhp","title":"YXqlV6LpoZGBNEN4Kkbm","moreInfo":"alf2UX9KIm1ZxJ5ZYWx0"};